import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {appRoutes} from './app.routes';
import {MissingTranslationHandler, TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {createCustomMissingTranslationHandler, createTranslateLoader} from './app.component';
import {HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import {UserState} from '../shared/user-state/user.state';
import {NgxsStoragePluginModule, STORAGE_ENGINE} from '@ngxs/storage-plugin';
import {NgxsModule} from '@ngxs/store';
import {PersistentStorageEngine} from './classes/persistent-storage-engine.class';
import {CustomHttpErrorInterceptor} from './classes/custom-http-error-interceptor';
import {ApiModule} from '@digitale-menschen/bandmanager-rest-api';
import {ENVIRONMENT} from '../environments/environment';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([CustomHttpErrorInterceptor])),
    provideFirebaseApp(() => initializeApp(ENVIRONMENT.firebase_config)),
    importProvidersFrom(
      TranslateModule.forRoot({
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useFactory: createCustomMissingTranslationHandler,
        },
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
      ApiModule.forRoot({
        rootUrl: ENVIRONMENT.apiConfiguration.baseUrl,
      }),
      NgxsModule.forRoot(
        [
          UserState
        ],
        {
          // developmentMode: !environment.production,
          selectorOptions: {
            suppressErrors: false
          },
        },
      ),
      NgxsStoragePluginModule.forRoot({
        keys: [
          'UserState',
          'BandState',
          'DeviceState',
        ],
      }),
    ),
    {
      provide: STORAGE_ENGINE,
      useClass: PersistentStorageEngine,
    },
  ]
};
